import axios from 'axios'
import { URL } from '../../util/ambienteActions';
import { LISTAR_FILTROS_EMPRESAS } from '../types';

export default function listarFiltrosEmpresas () {
  const url = `${URL}/empresas/filtros`;

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_EMPRESAS,
        payload: response

      })
  );
}
